/* Stonepacker contact obfuscation.
   Reveals email and phone numbers in browser only.
   Raw HTML has base64-encoded parts so HTML scrapers see nothing useful.
   On click (or focus for accessibility), JS builds the real mailto: / tel: link. */
(function () {
  function decode(s) {
    try { return atob(s); } catch (e) { return ''; }
  }

  function buildMail(el) {
    var u = el.getAttribute('data-u');
    var d = el.getAttribute('data-d');
    if (!u || !d) return;
    var user = decode(u);
    var domain = decode(d);
    if (!user || !domain) return;
    var addr = user + '@' + domain;
    if (el.tagName === 'A') {
      el.setAttribute('href', 'mailto:' + addr);
    }
    if (el.getAttribute('data-show') !== 'false' && !el.dataset.spRevealed) {
      el.textContent = addr;
      el.dataset.spRevealed = '1';
    }
  }

  function buildTel(el) {
    var n = el.getAttribute('data-n');
    if (!n) return;
    var formatted = decode(n);
    if (!formatted) return;
    var raw = formatted.replace(/[^\d+]/g, '');
    if (el.tagName === 'A') {
      el.setAttribute('href', 'tel:' + raw);
    }
    if (el.getAttribute('data-show') !== 'false' && !el.dataset.spRevealed) {
      el.textContent = formatted;
      el.dataset.spRevealed = '1';
    }
  }

  function revealMails() {
    document.querySelectorAll('.sp-obf-mail').forEach(buildMail);
  }
  function revealTels() {
    document.querySelectorAll('.sp-obf-tel').forEach(buildTel);
  }

  function init() {
    // Reveal on first user interaction. This means HTML-only scrapers and
    // dumb JS bots that don't simulate mouse/keyboard never see the address.
    var events = ['mousemove', 'touchstart', 'keydown', 'scroll', 'focusin'];
    var revealed = false;
    function doReveal() {
      if (revealed) return;
      revealed = true;
      revealMails();
      revealTels();
      events.forEach(function (e) { window.removeEventListener(e, doReveal, true); });
    }
    events.forEach(function (e) { window.addEventListener(e, doReveal, { capture: true, passive: true }); });

    // Also reveal individually on click/focus, in case interaction event missed
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.sp-obf-mail, .sp-obf-tel');
      if (!t) return;
      if (t.classList.contains('sp-obf-mail')) buildMail(t);
      if (t.classList.contains('sp-obf-tel')) buildTel(t);
    }, true);
    document.addEventListener('focusin', function (e) {
      if (e.target.classList.contains('sp-obf-mail')) buildMail(e.target);
      if (e.target.classList.contains('sp-obf-tel')) buildTel(e.target);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
